"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLabelProperty = exports.labelPropertyDefinition = void 0;
exports.labelPropertyDefinition = {
    name: 'label',
    type: 'text',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    multiple: false,
    view: { label: 'Label' },
};
const isLabelProperty = (prop) => {
    return prop.name === exports.labelPropertyDefinition.name;
};
exports.isLabelProperty = isLabelProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFiZWwucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9sYWJlbC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRSxPQUFPO0lBQ2IsSUFBSSxFQUFFLE1BQU07SUFDWixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtDQUNPLENBQUE7QUFJMUIsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFrQixFQUF5QixFQUFFO0lBQzNFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQkFBdUIsQ0FBQyxJQUFJLENBQUE7QUFDbkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxlQUFlLG1CQUUzQiJ9